<template>
  <div>
    <h3 class="title" style="margin: 0; padding-bottom: 0">输入预估信息</h3>
    <a-form :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="配方名称">
        <span>{{ animalData.formulaName }}</span>
      </a-form-item>
      <a-form-item label="配方代码">
        <span>{{ animalData.formulaCode }}</span>
      </a-form-item>
    </a-form>
    
    <h3 class="title title_mark">生长性能</h3>
    <a-form :form="form" :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="当前动物类型">
          <span>{{ animalData.animalTypeName }}</span>
        </a-form-item>

      <!-- <a-form-item label="当前配方适用体重">
        <span v-if="animalData.animalTypeName">{{ animalData.animalTypeName|filter_weight }}</span>
      </a-form-item> -->
      <a-form-item label="配方适用的体重阶段" v-if="growing">
        <span v-if="animalData.animalTypeName">{{startWeight}} - {{endWeight}}kg</span>
      </a-form-item>
      <a-form-item label="配方适用的平均体重" v-if="weaned">
        <span v-if="animalData.animalTypeName">{{ params.averageWeight || 0 }}kg</span>
      </a-form-item>
      <a-form-item label="配方适用的日期阶段" v-if="gestation">
        <span v-if="animalData.animalTypeName">{{startDay}} - {{endDay}}天</span>
      </a-form-item>
      <a-form-item label="哺乳期天数" v-if="sucklingow">
        <a-input-number class="inputClass" @change="changeVal" v-decorator="['lactationLength',{rules: [{ required: true, message: '请输入' }]}]" :min="5" :max="42"/>
        <span class="unitClass">天</span>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import moment from "moment";
import { getRequest } from "@/components/Common/Utils/Utils";
export default {
  props: ["formData", "animalData",'details'],
  data() {
    return {
      form: this.$form.createForm(this),
      params: JSON.parse(getRequest('params'))
    };
  },
  computed:{
    growing(){
      return this.params.predictionTypeCode === "growingFinishing";
    },
    weaned(){
      return this.params.predictionTypeCode === "startingPigs";
    },
    gestation(){
      return this.params.predictionTypeCode === "gestatingSows";
    },
    sucklingow(){
      return this.params.predictionTypeCode === "lactatingSows";
    },
    startWeight(){
      let {weightArr=[]} = this.params || {}
      let startWeight = weightArr[0] ? weightArr[0] : 0
      return startWeight
    },
    endWeight(){
      let {weightArr=[]} = this.params || {}
      let endWeight = weightArr[1] ? weightArr[1] : 0
      return endWeight
    },
    startDay(){
      let {day=[]} = this.params || {}
      let startDay = day[0] ? day[0] : 0
      return startDay
    },
    endDay(){
      let {day=[]} = this.params || {}
      let endDay = day[1] ? day[1] : 0
      return endDay
    },
  }, 
  watch: {
    formData: {
      handler(val) { 
        let { animalTypeId, name } = val;
        // lactationLength
        if (animalTypeId) this.form.setFieldsValue({ name });
      },
      deep: true,
    },
    details: {
      handler(val) {
        let {growthLactating} = val || {}
        let {lactationLength} = growthLactating || {}
        if(lactationLength) this.form.setFieldsValue({ lactationLength });
      },
      deep: true,
    },
  },

  filters:{
    filter_weight(value){
      if (value.includes("教槽")) {
        return "10kg";
      } else if (value.includes("保育前期")) {
        return "10kg";
      } else if (value.includes("保育后期")) {
        return "15kg";
      } else if (value.includes("生长猪")) {
        return "25-50kg";
      } else if (value.includes("育肥猪")) {
        return "50-100kg";
      } else if (value.includes("大猪")) {
        return "100-140kg";
      }
    }
  },

  methods: {
    changeVal(val){
      this.$emit('setDetail',val)
    },
    setName(animalTypeName) {
      let name = moment(new Date()).format("YYYYMMDD") + "_" + animalTypeName;
      this.form.setFieldsValue({ name });
    },
  },
};
</script>
<style scoped>
span {
  font-size: 13px;
}
</style>